import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs as MuiBreadcrumbs, Icon, useTheme } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

interface BreadcrumbsProps {
  icon: React.ReactNode;
  title: string | string[];
  route: string | string[];
  light?: boolean;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ icon, light = false }) => {
  const theme = useTheme();

  // 👇 Temporary cast since SoftTypography is missing prop types
  const STypo = SoftTypography as any;

  return (
    <SoftBox style={{ marginRight: theme.spacing(8) }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: light ? theme.palette.common.white : theme.palette.grey[600],
          },
        }}
      >
        <Link to="#">
          <STypo
            variant="body2"
            color={light ? "white" : "dark"}
            style={{ opacity: light ? 0.8 : 0.5, lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </STypo>
        </Link>
      </MuiBreadcrumbs>
    </SoftBox>
  );
};

export default Breadcrumbs;
